<template>
  <span :class="className">
    <svg :width="width" :height="height" viewBox="0 0 50 64" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M1.42969 49.7774H48.5725V14.1998C41.5155 14.1998 35.7375 8.47894 35.7375 1.42188H1.42969V49.7774Z"
        fill="#C6D2F6"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M48.5729 11.6139L48.5699 11.6152L38.333 1.42373L38.3328 1.4227L38.3342 1.42071L37.1152 0.207161C36.982 0.0744864 36.8016 0 36.6135 0H1C0.447715 0 0 0.447715 0 1V63C0 63.5523 0.447715 64 1 64H49C49.5523 64 50 63.5523 50 63V13.3315C50 13.1415 49.9243 12.9593 49.7897 12.8253L48.5729 11.6139ZM48.5714 48.7778C48.5714 49.3301 48.1237 49.7778 47.5714 49.7778H2.42857C1.87629 49.7778 1.42857 49.3301 1.42857 48.7778V2.42222C1.42857 1.86994 1.87629 1.42222 2.42857 1.42222H34.7364C35.2887 1.42222 35.7364 1.86994 35.7364 2.42222V13.2002C35.7364 13.7525 36.1841 14.2002 36.7364 14.2002H47.5714C48.1237 14.2002 48.5714 14.6479 48.5714 15.2002V48.7778Z"
        fill="#1A73E8"
      />
      <path
        d="M47.7162 12.7767L37.1641 2.27148V12.7767C41.2849 12.7767 43.5953 12.7767 47.7162 12.7767Z"
        fill="#A2B8F1"
      />
      <path
        d="M24.4901 41.6519L21.9742 35.6478H12.1531L9.66747 41.6519H7L15.6087 21H18.458L27.1879 41.6519H24.4901ZM13.0624 33.4434H21.0649L20.9436 33.1823C20.0039 30.9489 18.3064 26.8301 17.003 23.6395C15.7602 26.8301 14.0931 30.9489 13.1534 33.2113L13.0624 33.4434Z"
        fill="#1A73E8"
      />
      <path
        d="M40.575 26.6851H43V41.6519H40.6963V39.3605C39.5747 41.0428 37.756 42 35.422 42C31.0267 42 28.2683 38.9544 28.2683 34.1685C28.2683 29.3826 31.0267 26.337 35.422 26.337C37.6651 26.337 39.4232 27.2362 40.575 28.8025V26.6851ZM35.7251 39.9116C38.7563 39.9116 40.6356 37.7942 40.6356 34.1685C40.6356 30.5428 38.7563 28.4254 35.7251 28.4254C32.6938 28.4254 30.8145 30.6588 30.8145 34.2845C30.8145 37.9102 32.6938 39.9116 35.7251 39.9116Z"
        fill="#1A73E8"
      />
    </svg>
  </span>
</template>
<script type="text/ecmascript-6">
export default {
  name: 'TextIcon',
  props: {
    width: {
      type: String,
      default: '50px'
    },
    height: {
      type: String,
      default: '64px'
    },
    className: {
      type: String,
      default: ''
    }
  }
}
</script>
